export default {
  closeModalAriaLabel: 'close modal',
};
